import { Component, forwardRef, HostBinding, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

const noop = () => {};

@Component({
  selector: 'app-ep-checkbox',
  templateUrl: './ep-checkbox.component.html',
  styleUrls: ['./ep-checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EpCheckboxComponent),
      multi: true,
    },
  ],
})
export class EpCheckboxComponent implements ControlValueAccessor {
  @Input() disabled = false;
  private innerValue: boolean = false;

  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: boolean) => void = noop;

  @HostBinding('style.opacity')
  get opacity() {
    return this.disabled ? 0.25 : 1;
  }

  get value(): boolean {
    return this.innerValue;
  }

  set value(v: boolean) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(v);
    }
  }

  public writeValue(obj: boolean): void {
    if (obj !== this.innerValue) {
      this.innerValue = obj;
    }
  }

  public registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
